import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import Notice from '@/Components/Notice';
import { Noticeable } from '@/types';
import { EmergencyBanner } from '@/Components/EmergencyBanner/EmergencyBanner';
import { useEmergencyBannerHeight } from '@/Components/EmergencyBanner/useEmergencyBannerHeight';
import { PendingTemplateProvider } from '@/provider/PendingTemplate';

type GuestLayoutProps = Noticeable<PropsWithChildren> & {
    className?: string;
    showEmergencyBanner?: boolean;
    innerContentContainerClassName?: string;
    outerContentContainerClassName?: string;
};

export const GuestLayout: FC<GuestLayoutProps> = ({
    children,
    notice,
    className,
    showEmergencyBanner,
    innerContentContainerClassName,
    outerContentContainerClassName,
}) => {
    const emergencyBannerHeight = useEmergencyBannerHeight();

    const topIndent = showEmergencyBanner ? emergencyBannerHeight : 0;

    return (
        <PendingTemplateProvider>
            <div className="h-screen relative flex flex-col">
                {showEmergencyBanner && <EmergencyBanner />}

                <div
                    className={classNames(
                        'flex items-center justify-center',
                        className,
                    )}
                    style={{
                        height: `calc(100% - ${topIndent}px)`,
                    }}>
                    <div id="feathers"></div>
                    <div className="w-full flex items-center justify-center">
                        <div
                            className={classNames(
                                'absolute top-0 left-14 z-10 min-w-[320px] max-[425px]:max-w-[320px] lg:max-w-[25rem] max-w-[22rem] max-[768px]:w-full max-[768px]:static',
                                outerContentContainerClassName,
                            )}>
                            {notice && (
                                <Notice title={notice.title}>
                                    <p>{notice.body}</p>
                                </Notice>
                            )}
                            <div
                                className={classNames(
                                    'px-10 py-8 bg-neutral-light border-t-2 border-brand-teal grid gap-4',
                                    innerContentContainerClassName,
                                )}>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PendingTemplateProvider>
    );
};
